// Wayne AI Platform — TanStack Query client factory.
//
// Per FRONTEND_PLAN.md L7: TanStack Query owns ALL server state. Server state
// in Zustand is a bug. This factory is the single place where the QueryClient
// is configured, and it MUST be called before any component renders.
//
// Defaults:
//   - `staleTime: 30_000` so we don't re-fetch on every tab focus.
//   - `refetchOnWindowFocus: false` for the same reason.
//   - `retry: false` for `ApiError` (401s have already redirected; 4xxs don't
//     get better with another try). All other errors retry up to 2 times.

import { QueryClient } from '@tanstack/react-query';
import { ApiError, configureApiClient } from './client';

/** Build a QueryClient with the Wayne defaults. Idempotent. */
export function createQueryClient(): QueryClient {
  // Make sure interceptors are wired before any query runs.
  configureApiClient();

  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          // ApiError (any 4xx) and the 401-redirect throw should not retry.
          if (error instanceof ApiError) return false;
          return failureCount < 2;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
}
